import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MarketingApiService } from 'src/app/services/api/marketing-api.service';
import { OrderApiService } from 'src/app/services/api/order-api.service';
import { ProductApiService } from 'src/app/services/api/product-api.service';
import { MessageService } from 'src/app/services/message.service';
import { UserService } from 'src/app/services/user.service';
import { OrderConfirmDialogComponent } from '../../order-confirm-dialog/order-confirm-dialog.component';

@Component({
  selector: 'app-midjourney-dialog',
  templateUrl: './midjourney-dialog.component.html',
  styleUrls: ['./midjourney-dialog.component.scss'],
})
export class MidjourneyDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<MidjourneyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productApi: ProductApiService,
    private orderApi: OrderApiService,
    private message: MessageService,
    private user: UserService,
    private router: Router,
    private dialog: MatDialog
  ) {}
  selected: any = null;
  busTypes: any[] = [];
  self: any = null;
  ngOnInit(): void {

  }

}
